import styles from './PhysicsCascade.module.css';

export const PhysicsCascade = () => (
  <figure className={styles.figure} aria-label="Brain wakes briefly to reopen the airway during a single apnea event">
    <div className={styles.stage}>
      <svg viewBox="0 0 280 240" className={styles.svg} aria-hidden="true">
        <text x="140" y="14" textAnchor="middle" className={styles.topLabel}>
          A SINGLE APNEA EVENT
        </text>

        {/* BRAIN */}
        <g transform="translate(140, 60)">
          <g className={styles.brainPulse}>
            <circle cx="0" cy="0" r="44" fill="none" stroke="var(--osa-accent-alarm)" strokeWidth="1.4" opacity="0.4" />
            <circle cx="0" cy="0" r="32" fill="none" stroke="var(--osa-accent-alarm)" strokeWidth="1.6" opacity="0.7" />
          </g>
          <g className={styles.brainShape}>
            <path
              d="M -28 -4 C -32 -22, -16 -30, -2 -24 C -2 -26, 2 -26, 2 -24 C 16 -30, 32 -22, 28 -4 C 32 8, 22 22, 6 20 C 4 24, -4 24, -6 20 C -22 22, -32 8, -28 -4 Z"
              fill="var(--osa-tissue-fill)"
              stroke="var(--osa-tissue-stroke)"
              strokeWidth="1.6"
              strokeLinejoin="round"
            />
            <path
              d="M 0 -24 Q -2 -10, 0 0 Q 2 10, 0 20"
              fill="none"
              stroke="var(--osa-tissue-stroke)"
              strokeWidth="1.2"
              strokeLinecap="round"
              opacity="0.7"
            />
            <path
              d="M -22 -8 Q -16 -4, -10 -8"
              fill="none"
              stroke="var(--osa-tissue-stroke)"
              strokeWidth="1.1"
              strokeLinecap="round"
              opacity="0.6"
            />
            <path
              d="M -22 4 Q -16 8, -10 4"
              fill="none"
              stroke="var(--osa-tissue-stroke)"
              strokeWidth="1.1"
              strokeLinecap="round"
              opacity="0.6"
            />
            <path
              d="M -18 -16 Q -12 -12, -6 -16"
              fill="none"
              stroke="var(--osa-tissue-stroke)"
              strokeWidth="1.1"
              strokeLinecap="round"
              opacity="0.5"
            />
            <path
              d="M 10 -8 Q 16 -4, 22 -8"
              fill="none"
              stroke="var(--osa-tissue-stroke)"
              strokeWidth="1.1"
              strokeLinecap="round"
              opacity="0.6"
            />
            <path
              d="M 10 4 Q 16 8, 22 4"
              fill="none"
              stroke="var(--osa-tissue-stroke)"
              strokeWidth="1.1"
              strokeLinecap="round"
              opacity="0.6"
            />
            <path
              d="M 6 -16 Q 12 -12, 18 -16"
              fill="none"
              stroke="var(--osa-tissue-stroke)"
              strokeWidth="1.1"
              strokeLinecap="round"
              opacity="0.5"
            />
          </g>
        </g>
        <text x="140" y="100" textAnchor="middle" className={styles.partLabel}>
          BRAIN
        </text>

        <line
          className={styles.wakeSignal}
          x1="140"
          y1="106"
          x2="140"
          y2="128"
          stroke="var(--osa-accent-alarm)"
          strokeWidth="1.6"
          strokeLinecap="round"
        />

        <text x="140" y="120" textAnchor="middle" className={styles.partLabel}>
          AIRWAY
        </text>

        {/* AIRWAY */}
        <g className={styles.wallLeft}>
          <path d="M64 132 Q92 150 92 170 Q92 190 64 208 L64 132 Z" fill="var(--osa-tissue-fill)" />
          <path
            d="M64 132 Q92 150 92 170 Q92 190 64 208"
            fill="none"
            stroke="var(--osa-tissue-stroke)"
            strokeWidth="1.4"
          />
        </g>
        <g className={styles.wallRight}>
          <path d="M216 132 Q188 150 188 170 Q188 190 216 208 L216 132 Z" fill="var(--osa-tissue-fill)" />
          <path
            d="M216 132 Q188 150 188 170 Q188 190 216 208"
            fill="none"
            stroke="var(--osa-tissue-stroke)"
            strokeWidth="1.4"
          />
        </g>
        <g className={styles.airflow}>
          {[138, 150, 164, 180, 194].map((y1, i) => {
            const heights = [8, 10, 12, 10, 10];
            const opacities = [1, 0.9, 0.8, 0.7, 0.6];
            return (
              <line
                key={y1}
                x1="140"
                y1={y1}
                x2="140"
                y2={y1 + heights[i]}
                stroke="var(--osa-accent-healthy)"
                strokeWidth="2"
                strokeLinecap="round"
                opacity={opacities[i]}
              />
            );
          })}
        </g>
        <g className={styles.alarmMarker}>
          <circle
            cx="140"
            cy="170"
            r="14"
            fill="none"
            stroke="var(--osa-accent-alarm)"
            strokeWidth="1.4"
            opacity="0.5"
          />
          <circle cx="140" cy="170" r="7" fill="none" stroke="var(--osa-accent-alarm)" strokeWidth="1.6" />
          <circle cx="140" cy="170" r="2.5" fill="var(--osa-accent-alarm)" />
        </g>

        <text
          x="140"
          y="230"
          textAnchor="middle"
          className={`${styles.statusLabel} ${styles.labelBreathing}`}
          fill="var(--osa-accent-healthy)"
        >
          BREATHING
        </text>
        <text
          x="140"
          y="230"
          textAnchor="middle"
          className={`${styles.statusLabel} ${styles.labelCollapse}`}
          fill="var(--osa-accent-alarm)"
        >
          COLLAPSE
        </text>
        <text
          x="140"
          y="230"
          textAnchor="middle"
          className={`${styles.statusLabel} ${styles.labelWake}`}
          fill="var(--osa-accent-alarm)"
        >
          BRAIN WAKES YOU
        </text>
        <text
          x="140"
          y="230"
          textAnchor="middle"
          className={`${styles.statusLabel} ${styles.labelReopen}`}
          fill="var(--osa-accent-healthy)"
        >
          GASP · REOPEN
        </text>
      </svg>
    </div>
  </figure>
);

export default PhysicsCascade;
